<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Użytkownicy naboru</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Zmień rolę</span>
				</v-card-title>
				<v-card-text>
					<v-flex xs12 sm6 md4>
						<v-autocomplete name="rola" v-model="requestedRole" :items="contestRoles"
							label="rola"
							aria-label="requested role"
							for="agency-contest-user-table-role"
							id="agency-contest-user-table-rdialogole"
							data-vv-name="role"
							data-vv-as="role"
							:error-messages="vErrors.collect('department')"
							v-validate="'required'"></v-autocomplete>
					</v-flex>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" :disabled="!requestedRole" flat
						@click="saveRole(requestedRole);  dialog = false;">Zapisz
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<AddAgencyContestUserMenu :possibilities="possibilities" @save="saveUser"/>
		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:loading="loading"
			:items="users">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.surname }}</td>
				<td>{{ props.item.email }}</td>
				<td>
					{{ contestRoleToString(props.item.role)}}
				</td>
				<td>
					<v-icon small class="mr-2"
						@click="dialog = true; editedItem = props.item" title="Edytuj">
						edit
					</v-icon>
					<v-icon color="lightred" small class="mr-2"
						@click="deleteUser(props.item.id)" title="Usuń">
						delete
					</v-icon>
				</td>
			</template>
		</v-data-table>

	</div>
</template>

<script>
	import {Api} from "../../../../api";
	import AddAgencyContestUserMenu from "./AddAgencyContestUserMenu";

	export default {

		name: "AgencyContestUserTable",
		components: {AddAgencyContestUserMenu},

		data() {


			return {
				dialog: false,
				loading: false,
				showDuplicateNameMessage: false,
				requestedRole: "",
				contestRoles: [
					"Brak",
					"Sekretarz naboru",
					"Sekretarz naboru (główny)",
					"Członek zespołu",
					"Przewodniczący zespołu",
					"Przewodniczący zespołu (główny)"
				],
				tableHeaders: [
					{
						text: "Imię",
						sortable: false,
					},
					{
						text: "Nazwisko",
						sortable: false,
					},
					{
						text: "E-mail",
						sortable: false,
					},
					{
						text: "Rola w naborze",
						sortable: false,
					},
					{
						text: "Akcja",
						value: "action",
						sortable: false,
					},
				],
				editedItem: {},

				editedIndex: -1,
			};
		},

		props: {
			users: Array,
			possibilities: Array,
		},

		watch: {
			dialog(val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
				this.discardDuplicateNameError();
			},
		},

		computed: {
			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		methods: {
			contestRoleToString(role) {
				if (role === "LEADER") return "Przewodniczący zespołu";
				if (role === "MAIN_LEADER") return "Przewodniczący zespołu (główny)";
				if (role === "SECRETARY") return "Sekretarz naboru";
				if (role === "MAIN_SECRETARY") return "Sekretarz naboru (główny)";
				if (role === "COMMITTEE_USER") return "Członek zespołu";
				if (role === "NONE") return "-";
				return "nierozpoznana rola";
			},

			discardDuplicateNameError() {
				this.showDuplicateNameMessage = false;
			},

			deleteUser(id) {
				this.$confirm("Czy na pewno chcesz usunąć tego użytkownika? Jeżeli aktualnie jest członkiem jakiegoś zespołu nie będzie to możliwe.", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie użytkownika naboru",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.delete(this, "/agency-contest/user"
									+ "?contestUserId=" + id
								, null, () => {
									Api.get(this, "/agency-contest/users" + "?contestId=" + this.$route.params.id, () => {
										this.$emit("refresh");
									});
								},
								(errorResponse) => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć użytkownika. Sprawdź, czy nie jest członkiem jakiegoś zespołu." +
										"\n", errorResponse);
								});
						}
					});
			},

			saveRole (role) {
				Api.post(this, "/agency-contest/user-contest-role"
						+ "?contestUserId=" + this.editedItem.id
						+ "&newRole=" + role
					, null, () => {
						Api.get(this, "/agency-contest/users" + "?contestId=" + this.$route.params.id, () => {
							this.$emit("refresh");
						});
					});
			},
			saveUser (userToAdd) {
				Api.put(this, "/agency-contest/user"
						+ "?contestId=" + this.$route.params.id
						+ "&userId=" + userToAdd
					, null, () => {
						this.$messagesBus.$emit("success", "Dodano użytkownika do naboru");
						Api.get(this, "/agency-contest/users" + "?contestId=" + this.$route.params.id, () => {
							this.$emit("refresh");
						});
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
					},
				);

			}
		},
	};
</script>

<style scoped>

</style>
